export default __webpack_public_path__ + "static/mv_illustration-f22777bdcea26f408df9b0349c9392dd.svg";